import { render, staticRenderFns } from "./AppScoresNFLStatistics.vue?vue&type=template&id=14767402&"
import script from "./AppScoresNFLStatistics.vue?vue&type=script&lang=js&"
export * from "./AppScoresNFLStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports